<template>
  <div>
    <div class="h footerIOS" style="min-height: 0.54rem;"></div>
    <ul class="footer footerIOS">
      <li
        :class="{ footers: activeTabKey === item._tab }"
        class="flex-1"
        :key="item._tab + '-' + index"
        v-for="(item, index) of listData"
      >
        <div :class="{ homeIconTags: homeIcon && item._tab === 'home' }" class="tagsImg" @click="footerClick(item)">
          <i v-if="item._tab === 'cart' && cartnum > 0"></i>
          <img
            :class="{ homeIcon: homeIcon && item._tab === 'home' }"
            :src="item.changeIcon"
            v-if="activeTabKey === item._tab"
          />
          <img :class="{ homeIcon: homeIcon && item._tab === 'home' }" :src="item.icon" v-else />
        </div>
        <p @click="footerClick(item)" class="ta-c">{{ item.title }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'footerComp',
  data() {
    return {
      listData: [],
      tagValue: 99,
      homeIcon: ''
    }
  },
  props: {
    footerIndex: {
      type: Number,
      default: 0
    },
    cartnum: {
      type: Number,
      default: 0
    },
    isNewPage: {
      type: Number,
      default: -1
    },
    showOnlyTheEntrance: {
      type: Array,
      default: () => []
    },
    tabbarText1: {
      type: String,
      default: ''
    }
  },
  computed: {
    /** 与父组件 footerIndex 对应的语义 tab（完整五键时的下标含义） */
    activeTabKey() {
      const order = this.homeIcon
        ? ['category', 'community', 'home', 'cart', 'my']
        : ['home', 'category', 'community', 'cart', 'my']
      return order[this.footerIndex] || ''
    }
  },
  watch: {
    showOnlyTheEntrance: {
      handler() {
        this.rebuildTabList()
      },
      deep: true
    },
    isNewPage() {
      this.rebuildTabList()
    }
  },
  mounted() {
    // // 挂载完成后，判断浏览器是否支持popstate
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false);
    // }
    this.hasNewMsg()
  },
  destroyed() {
    // window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    // goBack() {
    //   // 个人中心进入返回上一级，支付后进入返回首页
    //   if (!this.$route.query.route) {
    //     this.$router.replace({path: '/'})
    //   } else {
    //     history.go(-1);
    //   }
    // },
    titleToTabKey(title) {
      if (title === this.tabbarText1 || title === '首页') return 'home'
      if (title === '分类' || title === '专区') return 'category'
      if (title === '社区') return 'community'
      if (title === '购物车') return 'cart'
      if (title === '我的') return 'my'
      return null
    },
    applyShowOnlyEntrance(fullList) {
      if (!this.showOnlyTheEntrance || !this.showOnlyTheEntrance.length) {
        this.listData = fullList
        return
      }
      const byTab = {}
      fullList.forEach((item) => {
        byTab[item._tab] = item
      })
      const next = []
      this.showOnlyTheEntrance.forEach((title) => {
        const tab = this.titleToTabKey(title)
        if (tab && byTab[tab] && !next.some((x) => x._tab === tab)) {
          next.push(byTab[tab])
        }
      })
      this.listData = next.length ? next : fullList
    },
    createFullTabList(tabBarItem) {
      if (this.homeIcon) {
        return [
          { ...tabBarItem, _tab: 'category' },
          {
            icon: require('../../assets/images/community.png'),
            changeIcon: require('../../assets/images/community1.png'),
            title: '社区',
            _tab: 'community'
          },
          {
            icon: this.homeIcon,
            changeIcon: this.homeIcon,
            title: '',
            _tab: 'home'
          },
          {
            icon: require('../../assets/images/goshopping.png'),
            changeIcon: require('../../assets/images/goshopping1.png'),
            title: '购物车',
            _tab: 'cart'
          },
          {
            icon: require('../../assets/images/my.png'),
            changeIcon: require('../../assets/images/my1.png'),
            title: '我的',
            _tab: 'my'
          }
        ]
      }
      return [
        {
          icon: require('../../assets/images/home.png'),
          changeIcon: require('../../assets/images/home1.png'),
          title: this.tabbarText1 || '首页',
          _tab: 'home'
        },
        { ...tabBarItem, _tab: 'category' },
        {
          icon: require('../../assets/images/community.png'),
          changeIcon: require('../../assets/images/community1.png'),
          title: '社区',
          _tab: 'community'
        },
        {
          icon: require('../../assets/images/goshopping.png'),
          changeIcon: require('../../assets/images/goshopping1.png'),
          title: '购物车',
          _tab: 'cart'
        },
        {
          icon: require('../../assets/images/my.png'),
          changeIcon: require('../../assets/images/my1.png'),
          title: '我的',
          _tab: 'my'
        }
      ]
    },
    rebuildTabList() {
      let tabBarItem = {}
      if (this.isNewPage == 1) {
        tabBarItem = {
          icon: require('../../assets/images/brandicon.png'),
          changeIcon: require('../../assets/images/brandicon1.png'),
          title: '专区'
        }
      } else if (this.isNewPage == 0) {
        tabBarItem = {
          icon: require('../../assets/images/classification.png'),
          changeIcon: require('../../assets/images/classification1.png'),
          title: '分类'
        }
      } else {
        tabBarItem = {
          icon: require('../../assets/images/classification.png'),
          changeIcon: require('../../assets/images/classification1.png'),
          title: '分类'
        }
      }
      const full = this.createFullTabList(tabBarItem)
      this.applyShowOnlyEntrance(full)
    },
    async hasNewMsg() {
      let { data } = await this.$customRequestAjax(this.$ajax.hasNewMsg_URL)
      this.homeIcon = data.data.homeicon
      this.rebuildTabList()
    },
    footerClick: function (item) {
      window.scrollTo(0, 0)
      let tabBarItem = {}
      if (this.isNewPage == 1) {
        tabBarItem = {
          buttonCode: 'brandbutton',
          path: '/brandlist'
        }
      } else if (this.isNewPage == 0) {
        tabBarItem = {
          buttonCode: 'classbutton',
          path: '/classification'
        }
      } else {
        tabBarItem = {
          buttonCode: 'classbutton',
          path: '/classification'
        }
      }
      const tab = item._tab
      if (tab === 'category') {
        this.$clickburiedPoint({
          data: {
            buttonCode: tabBarItem.buttonCode
          }
        })
        const channelid = this.$route.query.channelid
        const category_route =
          channelid !== undefined && channelid !== null && channelid !== ''
            ? { path: tabBarItem.path, query: { channelid: channelid } }
            : { path: tabBarItem.path }
        this.$router.push(category_route)
        return
      }
      if (tab === 'community') {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'communitybutton'
          }
        })
        this.$store.commit('COMMUNITY_TAB', 1)
        this.$router.push('/community')
        return
      }
      if (tab === 'home') {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'indexbutton'
          }
        })
        var route_name = this.$route.name
        var cid = this.$route.query.channelid
        var has_channelid =
          cid !== undefined && cid !== null && String(cid) !== ''
        if (
          has_channelid &&
          (route_name === 'homePageChannel' || route_name === 'category')
        ) {
          this.$router.push({
            path: '/indexchannel',
            query: { channelid: cid }
          })
        } else {
          this.$router.push('/')
        }
        return
      }
      if (tab === 'cart') {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'shopcartbutton'
          }
        })
        this.$router.push('/cart')
        return
      }
      if (tab === 'my') {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'mybutton'
          }
        })
        this.$router.push({ path: '/percen' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  background: #fff;
  padding: 0.08rem 0.2rem 0;
  display: flex;
  display: -moz-flex;
  display: -o-flex;
  display: -ms-flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  -o-justify-content: space-between;
  -ms-justify-content: space-between;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2001;
  box-shadow: 0px -1px 10px 0px rgba(236, 236, 236, 0.5);
  li {
    padding-bottom: 0.08rem;
    .tagsImg {
      width: 0.21rem;
      margin: 0 auto;
      position: relative;
      i {
        display: block;
        font-style: normal;
        position: absolute;
        min-width: 0.07rem;
        min-height: 0.07rem;
        background: rgba(252, 3, 36, 1);
        font-size: 0.1rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 0.15rem;
        border-radius: 50%;
        right: -40%;
        top: -15%;
      }
      img {
        width: 0.21rem;
        height: 0.21rem;
        margin-bottom: 0.01rem;
      }
      &.homeIconTags {
        width: 0.55rem;
      }
      .homeIcon {
        width: 0.55rem;
        height: 0.55rem;
        position: absolute;
        top: -0.2rem;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    img {
      width: 0.21rem;
      height: 0.21rem;
      margin: 0 auto;
      margin-bottom: 0.04rem;
    }
    p {
      font-size: 0.1rem;
      font-weight: 500;
      color: #333333;
    }
    &.footers {
      p {
        color: #fc0324;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footerComp.vue